import { Box, Pagination, Typography } from '@mui/material';

const MUTED = '#6B7280';

/**
 * The pager control: a left-side "N rows · page X of Y" summary and an MUI
 * Pagination on the right. Shown only when there is more than one page. Matches
 * the pagination look already used on the Performance Analysis table.
 *
 * @param {{ page: number, pageCount: number, total: number, onChange: (p:number)=>void, unit?: string }} props
 */
export default function FieldSalesPager({ page, pageCount, total, onChange, unit = 'rows' }) {
  if (pageCount <= 1) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mt: 1.5,
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <Typography sx={{ fontSize: '12px', color: MUTED }}>
        {total} {unit} · page {page} of {pageCount}
      </Typography>
      <Pagination
        count={pageCount}
        page={page}
        onChange={(_e, value) => onChange(value)}
        size="small"
        color="primary"
      />
    </Box>
  );
}
